// extracted by mini-css-extract-plugin
module.exports = {"sign-notes-detail":"sign-notes-detail-56a51933337238f068ebaa7b575faf89"};